import placeholderImage from 'assets/img/covers/placeholder.jpg';
import { Form } from 'components';
import SelectedItems from 'pages/ModulePage/components/SelectedItems/SelectedItems';
import SelectItemsModal from 'pages/ModulePage/components/SelectItemsModal/SelectItemsModal';
import { formatPrice } from 'utils/products';
import { useFormikContext } from 'formik';
import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

const getProductRowData = (item) => {
  const childProduct = item.product?.child_products?.[0]?.child_product;

  return {
    name: childProduct?.parent_product?.name,
    code: childProduct?.product_code,
    image: childProduct?.picture || placeholderImage,
    price: childProduct?.price,
    currency: childProduct?.currency || 'USD',
  };
};

const getProductKey = (item) => item.uid;

const filterProductBySearch = (item, query) => {
  const row = getProductRowData(item);
  const normalizedQuery = query.toLowerCase();

  return (
    (row.name || '').toLowerCase().includes(normalizedQuery) ||
    (row.code || '').toLowerCase().includes(normalizedQuery)
  );
};

const getProductItemCardProps = (item, { t }) => {
  const row = getProductRowData(item);
  const meta = [];
  if (row.code) meta.push({ label: t('productCode'), value: row.code });
  if (row.price != null) {
    meta.push({ label: t('price'), value: formatPrice(row.price, row.currency) });
  }
  return {
    imageSrc: row.image,
    imageAlt: row.code || 'Product',
    title: row.name || null,
    meta,
  };
};

export const createFavoriteProductsConfig = (useAvailableItems) => {
  const FavoriteProductsConfig = () => {
    const { t } = useTranslation('ownerPortal', { keyPrefix: 'pageModules' });
    const { values, setFieldValue } = useFormikContext();
    const { items, isLoading } = useAvailableItems();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [search, setSearch] = useState('');

    const selectedItems = useMemo(() => values.selectedItems || [], [values.selectedItems]);

    const filteredItems = useMemo(() => {
      if (!search.trim()) return items;
      return items.filter((item) => filterProductBySearch(item, search.trim()));
    }, [items, search]);

    return (
      <>
        <Form.GroupHorizontal label={t('selectedItems')}>
          <SelectedItems
            isLoading={isLoading}
            items={selectedItems}
            setItems={(next) => setFieldValue('selectedItems', next)}
            getItemKey={getProductKey}
            getItemCardProps={getProductItemCardProps}
            onOpenModal={() => setIsModalOpen(true)}
          />
        </Form.GroupHorizontal>
        <SelectItemsModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          onSelect={(next) => setFieldValue('selectedItems', next)}
          initialSelected={selectedItems}
          items={filteredItems}
          isLoading={isLoading}
          getItemKey={getProductKey}
          getItemCardProps={getProductItemCardProps}
          onSearch={setSearch}
          selectedFirst
        />
      </>
    );
  };

  return FavoriteProductsConfig;
};
